import React, { ComponentType, FC } from 'react'
import { AnyStyledComponent } from 'styled-components'

import {
    GoToMenuItemLinkIcon,
    MenuItemContainer,
    MenuItemContent,
    MenuItemIcon,
    MenuItemText,
} from './menu-item-styles'
import { useTranslation } from '../../../../hooks/locale'

interface Props {
    icon: ComponentType
    altText: string
    title: string
    link: string
}

const MenuItem: FC<Props> = ({ icon, altText, title, link }) => {
    const { t } = useTranslation()

    return (
        <MenuItemContainer>
            <MenuItemContent href={link}>
                <MenuItemIcon as={icon as AnyStyledComponent} alt={altText} />
                <MenuItemText>{title}</MenuItemText>
                <GoToMenuItemLinkIcon alt={t('goToMenuItemLinkIcon')} />
            </MenuItemContent>
        </MenuItemContainer>
    )
}

export default MenuItem
